import { Icon } from './Icon';
import './SoundButton.css';

// Round speaker toggle that sits on top of a video. Shows a tiny equaliser while sound is on.
export function SoundButton({ on, onToggle, size = 'md', className = '' }) {
    return (
        <button
            type="button"
            className={`soundBtn soundBtn--${size}${on ? ' soundBtn--on' : ''} ${className}`}
            onClick={(e) => { e.stopPropagation(); onToggle(); }}
            aria-pressed={on}
            aria-label={on ? 'Mute' : 'Turn sound on'}
            title={on ? 'Mute' : 'Sound on'}
        >
            {on ? (
                <span className="soundEq" aria-hidden="true"><i /><i /><i /><i /></span>
            ) : (
                <Icon name="soundOff" size={size === 'lg' ? 20 : 16} />
            )}
        </button>
    );
}
